import { AxiosResponse } from 'axios';
import { axiosInstance } from 'services';

import { IPremiumClient } from 'types/interfaces';

export const PremiumClients = {
    saveClient: (data: IPremiumClient): Promise<AxiosResponse<void>> => axiosInstance.post<void>('client', data),
};
